import axios from 'axios';

export default {
  getCustomerTypes: () => axios.get('customer-types'),
  getCustomerSizes: () => axios.get('customer-sizes'),
  getCustomerSectors: () => axios.get('customer-sectors'),
  getCustomerOrigins: () => axios.get('customer-origins'),
};
